import { Component, inject } from "@angular/core";
import { SubscriptionOverviewService } from "./data-access/subscription-overview.service";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { WorkflowOverviewService } from "./data-access/workflow-overview.service";
import { WorkflowViewComponent } from "./ui/workflow-view/workflow-view.component";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { FormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatCardModule } from "@angular/material/card";
import { MatDialog } from "@angular/material/dialog";
import { NewContractDialogComponent } from "projects/dora/src/app/features/home/ui/new-contract/new-contract-dialog/new-contract-dialog.component";
import { ProcessService } from "@shared-api/process/process.service";
import { TranslateModule } from '@ngx-translate/core';

export interface DialogData {
  workflowName: string;
}
@Component({
  selector: "home",
  standalone: true,
  imports: [
    MatProgressSpinnerModule,
    WorkflowViewComponent,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatCardModule,
    TranslateModule
  ],
  templateUrl: "./home.component.html",
  styleUrl: "./home.component.scss",
  providers: [
    {
      provide: WorkflowOverviewService,
      useClass: WorkflowOverviewService,
      deps: [],
    },
    {
      provide: ProcessService,
      useClass: ProcessService,
      deps: [],
    },
  ],
})
export class HomeComponent {
  subscriptionOverview = inject(SubscriptionOverviewService);
  selectedWorkflowId: string | undefined = undefined;
  dora_logo = "/assets/img/intro.png";
  deleteMode: boolean = false;
  workflowName: string | undefined;

  constructor(public dialog: MatDialog) {}

  ngOnInit(): void {
    this.subscriptionOverview.getSubscriptionData$.next();
  }

  createNewWorkflow(workflowName: string, workflowType: string): void {
    this.subscriptionOverview.createNewWorkflow$.next([
      workflowName,
      workflowType,
    ]);
  }

  deleteWorkflow(workflowId: string): void {
    if (this.selectedWorkflowId == workflowId) {
      this.selectedWorkflowId = undefined;
    }
    this.subscriptionOverview.deleteWorkflowId$.next(workflowId);
  }

  openWorkflow(workflowId: string): void {
    if (this.selectedWorkflowId != workflowId) {
      this.selectedWorkflowId = workflowId;
    }
  }

  newWorkflow(): void {
    let dialogRef = this.dialog.open(NewContractDialogComponent, {
      height: "fit-content",
      width: "max(200px, 400px)",
      data: { name: this.workflowName },
    });

    dialogRef.afterClosed().subscribe((workflowName: string) => {
      if (workflowName) {
        this.createNewWorkflow(workflowName, "contract");
      }
    });
  }
}
